"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

var _prospectingContacts = require("../../../../constants/prospectingContacts.schemas");

var _StyledTextField = require("./StyledTextField");

var _StyledFieldSkeleton = require("./StyledFieldSkeleton");

var CustomFieldCell = function CustomFieldCell(_ref) {
  var _field$value;

  var label = _ref.label,
      dataKey = _ref.dataKey,
      rowIndex = _ref.rowIndex,
      columnData = _ref.columnData,
      rowData = _ref.rowData;
  var name = "".concat(_prospectingContacts.ContactStepField.contacts, ".").concat(rowIndex, ".").concat(_prospectingContacts.CustomFieldsStepField.customFields, ".").concat(dataKey);

  var extractFieldName = function extractFieldName(message) {
    if (message) {
      var messageRegex = /^Contacts\.\d+\.customFields\.(\w+) is required$/i;
      var matches = message.match(messageRegex);
      return matches ? "".concat(matches[1], " is required") : message;
    }

    return null;
  };

  var _useController = (0, _reactHookForm.useController)({
    control: columnData === null || columnData === void 0 ? void 0 : columnData.control,
    name
  }),
      field = _useController.field,
      error = _useController.fieldState.error;

  var errorMessage = (0, _react.useMemo)(function () {
    if (error !== null && error !== void 0 && error.message) {
      return extractFieldName((error === null || error === void 0 ? void 0 : error.message) || null);
    }

    return null;
  }, [error]);
  return rowData !== null && rowData !== void 0 && rowData.id ? /*#__PURE__*/_react.default.createElement(_StyledTextField.StyledTextField, (0, _extends2.default)({
    fullWidth: true,
    variant: "outlined"
  }, field, {
    label: label,
    value: (_field$value = field.value) !== null && _field$value !== void 0 ? _field$value : '',
    error: !!errorMessage,
    helperText: errorMessage,
    disabled: columnData === null || columnData === void 0 ? void 0 : columnData.isLoading
  })) : /*#__PURE__*/_react.default.createElement(_StyledFieldSkeleton.StyledFieldSkeleton, {
    variant: "rect",
    width: "100%",
    height: 48
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(CustomFieldCell);

exports.default = _default;